import React, { useState } from 'react';
import { ArrowLeft, Menu, Settings } from 'lucide-react';
import IconQLogo from 'shared_items/icon_qlogo';
import OfflineStatusBadge from 'shared_items/OfflineStatusBadge';
import SidebarMenu from 'shared_items/SidebarMenu';

// Mapa explícito (não template string) — necessário pro Tailwind JIT. Ver docs/design-system/tokens.md
const BG_BY_MODULE = {
  finance: 'bg-module-finance',
  travel: 'bg-module-travel',
  planner: 'bg-module-planner',
  health: 'bg-module-health',
  core: 'bg-module-core',
  accounts: 'bg-module-accounts',
  notepad: 'bg-module-notepad',
  identity: 'bg-module-identity',
};

/**
 * NavbarTop compartilhado. Antes duplicado 7x (finance/travel/planner/health/core/accounts/notepad)
 * com cor hardcoded e leve divergência de comportamento no botão de settings.
 * Ver docs/design-system/decisions.md #002.
 *
 * - `moduleKey`: resolve a cor de fundo via token.
 * - `onSettingsClick`: settings do módulo. Sem callback, o botão não renderiza
 *   (Accounts — general settings fica no menu lateral).
 * - `settingsActive`: quem chama decide se o ícone é engrenagem ou voltar.
 */
const NavbarTop = ({
  title,
  moduleKey,
  onHomeClick,
  onSettingsClick,
  settingsActive = false,
  zIndexClass = '',
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const bgClass = BG_BY_MODULE[moduleKey] || 'bg-gray-700';

  return (
    <>
      <div className={`fixed top-0 left-0 right-0 ${bgClass} h-14 shadow flex items-center justify-between px-2 md:px-4 ${zIndexClass}`}>
        <div className="flex items-center gap-2">
          <button type="button" onClick={onHomeClick}
            className="bg-gray-800 p-2 rounded-full shadow-md hover:bg-opacity-60">
            <IconQLogo className="h-8 w-8 text-white" />
          </button>
          <h1 className="text-xl font-bold text-white">{title}</h1>
        </div>

        <div className="flex items-center">
          <OfflineStatusBadge />

          {onSettingsClick && (
            <button
              type="button"
              onClick={onSettingsClick}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full text-white hover:bg-white/10 transition-colors"
            >
              {settingsActive ? (
                <ArrowLeft className="h-5 w-5" strokeWidth={2} />
              ) : (
                <Settings className="h-5 w-5" strokeWidth={2} />
              )}
            </button>
          )}

          <button
            type="button"
            onClick={() => setSidebarOpen(true)}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-white hover:bg-white/10 transition-colors"
          >
            <Menu className="h-5 w-5" strokeWidth={2} />
          </button>
        </div>
      </div>

      <SidebarMenu isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
    </>
  );
};

export default NavbarTop;
